// removed by extract-text-webpack-plugin
module.exports = {"councilMapWrapper":"council-map-container-module__councilMapWrapper___2eUiQ","dataLegend":"council-map-container-module__dataLegend___3s5la"};


//////////////////
// WEBPACK FOOTER
// ./src/components/council-map-container/council-map-container.module.scss
// module id = 869
// module chunks = 0 1